import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import undoable from 'redux-undo';

import appReducer from '~app/features/app';
import canvasReducer from '~app/features/canvas';
import gradingReducer from '~app/features/gradingTool';
import modelReducer from '~app/features/landing';
import documentReducer, {
  undoGroupBy,
  undoFilter,
} from '~app/features/document';
import saveLoadReducer from '~app/features/saveLoad';

export default function createStore() {
  return configureStore({
    reducer: combineReducers({
      app: appReducer,
      document: undoable(documentReducer, {
        groupBy: undoGroupBy,
        filter: undoFilter,
        syncFilter: true,
      }),
      canvas: canvasReducer,
      saveLoad: saveLoadReducer,
      grading: gradingReducer,
      model: modelReducer,
    }),
    devTools:
      process.env.NODE_ENV !== 'production' ||
      process.env.ENABLE_DEVTOOLS === 'true',
  });
}
